import React, { forwardRef } from 'react';
import tw from 'twin.macro';
import { DeckProvider } from './DeckContext';

const SKUDeck = forwardRef(({ children, skuDeckOfferCommnuication = false, deckInfo = {} }, ref) => {
  const { packsizes = [], ...parent } = deckInfo;
  const totalPackSize = [parent, ...packsizes];

  return (
    <DeckProvider
      onInit={() => ({
        packSizes: totalPackSize,
        packSelected: totalPackSize[0],
      })}>
      <div
        css={[
          tw`xl:w-64.5  lg:w-53 lg:max-h-124  xl:max-h-137  flex flex-col p-2.5 cursor-pointer bg-white border border-silverSurfer-100 rounded-xs shadow-3 overflow-hidden`,
          !skuDeckOfferCommnuication && tw`gap-1 `,
        ]}
        ref={ref}>
        {children}
      </div>
    </DeckProvider>
  );
});

export default SKUDeck;
